import { gql } from '@apollo/client';

// Household fragment
export const HOUSEHOLD_FRAGMENT = gql`
  fragment HouseholdFields on Household {
    id
    name
    addressLine1
    addressLine2
    city
    state
    postalCode
    country
  }
`;

// Person fragments
export const PERSON_FRAGMENT = gql`
  ${HOUSEHOLD_FRAGMENT}
  fragment PersonFields on Person {
    id
    firstName
    middleName
    lastName
    preferredName
    phone
    email
    profilePictureUrl
    birthday
    deceasedDate
    gender
    householdId
    household {
      ...HouseholdFields
    }
    notes
    createdAt
    updatedAt
  }
`;

export const PERSON_WITH_RELATIONS_FRAGMENT = gql`
  ${PERSON_FRAGMENT}
  fragment PersonWithRelations on Person {
    ...PersonFields
    parents {
      id
      firstName
      lastName
      preferredName
      profilePictureUrl
    }
    children {
      id
      firstName
      lastName
      preferredName
      profilePictureUrl
    }
    spouses {
      id
      firstName
      lastName
      preferredName
      profilePictureUrl
    }
  }
`;

// Queries
export const GET_PERSONS = gql`
  ${PERSON_FRAGMENT}
  query GetPersons($search: String) {
    persons(search: $search) {
      ...PersonFields
    }
  }
`;

export const GET_PERSON = gql`
  ${PERSON_WITH_RELATIONS_FRAGMENT}
  query GetPerson($id: ID!) {
    person(id: $id) {
      ...PersonWithRelations
    }
  }
`;

export const GET_UPCOMING_BIRTHDAYS = gql`
  ${PERSON_FRAGMENT}
  query GetUpcomingBirthdays($limit: Int) {
    upcomingBirthdays(limit: $limit) {
      ...PersonFields
    }
  }
`;

export const GET_MESSAGE_BOARD_POSTS = gql`
  query GetMessageBoardPosts {
    messageBoardPosts {
      id
      authorName
      authorPerson {
        id
        firstName
        lastName
      }
      body
      createdAt
      pinned
    }
  }
`;

export const GET_RELATIONSHIPS = gql`
  query GetRelationships {
    relationships {
      id
      fromPersonId
      toPersonId
      type
      fromPerson {
        id
        firstName
        lastName
        preferredName
        profilePictureUrl
      }
      toPerson {
        id
        firstName
        lastName
        preferredName
        profilePictureUrl
      }
    }
  }
`;

export const GET_TREE_DATA = gql`
  query GetTreeData {
    persons {
      id
      firstName
      lastName
      preferredName
      profilePictureUrl
      birthday
      deceasedDate
    }
    relationships {
      id
      fromPersonId
      toPersonId
      type
    }
  }
`;

export const GET_INVITES = gql`
  query GetInvites {
    invites {
      id
      personId
      email
      token
      expiresAt
      redeemedAt
      person {
        id
        firstName
        lastName
      }
    }
  }
`;

export const GET_HOUSEHOLDS = gql`
  ${HOUSEHOLD_FRAGMENT}
  query GetHouseholds {
    households {
      ...HouseholdFields
      members {
        id
        firstName
        lastName
        preferredName
      }
    }
  }
`;

export const GET_CLOUDINARY_CONFIG = gql`
  query GetCloudinaryConfig {
    cloudinaryConfig {
      cloudName
      uploadPreset
    }
  }
`;
